module.exports = __webpack_public_path__ + "img/map-menu-5@2x.82792c2b.png";